module.exports = __webpack_public_path__ + "img/completed.23ee15ee.svg";